/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import {VerticalNavGroupRegistrationService} from './providers/vertical-nav-group-registration.service';
import {VerticalNavIconService} from './providers/vertical-nav-icon.service';
import {VerticalNavService} from './providers/vertical-nav.service';
export class VerticalNav implements OnDestroy {
/**
 * @return {?}
 */
get collapsible(): boolean {
        return this._navService.collapsible;
    }
/**
 * @param {?} value
 * @return {?}
 */
set collapsible(value: boolean) {
        this._navService.collapsible = value;
    }
/**
 * @return {?}
 */
get collapsed(): boolean {
        return this._navService.collapsed;
    }
/**
 * @param {?} value
 * @return {?}
 */
set collapsed(value: boolean) {
        this._navService.collapsed = value;
    }
private _collapsedChanged: EventEmitter<boolean> = new EventEmitter<boolean>(true);
/**
 * @return {?}
 */
get hasNavGroups(): boolean {
        return this._navGroupRegistrationService.navGroupCount > 0;
    }
/**
 * @return {?}
 */
get hasIcons(): boolean {
        return this._navIconService.hasIcons;
    }
private _sub: Subscription;
/**
 * @param {?} _navService
 * @param {?} _navIconService
 * @param {?} _navGroupRegistrationService
 */
constructor(private _navService: VerticalNavService,
private _navIconService: VerticalNavIconService,
private _navGroupRegistrationService: VerticalNavGroupRegistrationService) {
        this._sub = this._navService.collapsedChanged.subscribe(value => {
            this._collapsedChanged.emit(value);
        });
    }
/**
 * @return {?}
 */
toggleByButton() {
        this.collapsed = !this.collapsed;
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this._sub.unsubscribe();
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-vertical-nav",
    template: `
      <button type="button" class="nav-trigger"
              [class.on-collapse]="collapsed"
              (click)="toggleByButton()"
              *ngIf="collapsible">
          <clr-icon shape="angle-double" class="nav-trigger-icon" [attr.dir]="(this.collapsed) ? 'right' : 'left'"></clr-icon>
      </button>
      <!-- Click handler on .nav-content is bad but required :-( -->
      <div class="nav-content">
          <ng-content></ng-content>
          <button (click)="collapsed = false" class="nav-btn" *ngIf="collapsible && collapsed"></button>
      </div>
    `,
    providers: [VerticalNavService, VerticalNavIconService, VerticalNavGroupRegistrationService],
    host: {
        "class": "clr-vertical-nav",
        "[class.is-collapsed]": "collapsed",
        "[class.has-nav-groups]": "hasNavGroups",
        "[class.has-icons]": "hasIcons"
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: VerticalNavService, },
{type: VerticalNavIconService, },
{type: VerticalNavGroupRegistrationService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'collapsible': [{ type: Input, args: ["clrVerticalNavCollapsible", ] },],
'collapsed': [{ type: Input, args: ["clrVerticalNavCollapsed", ] },],
'_collapsedChanged': [{ type: Output, args: ["clrVerticalNavCollapsedChange", ] },],
};
}

function VerticalNav_tsickle_Closure_declarations() {
/** @type {?} */
VerticalNav.decorators;
/**
 * @nocollapse
 * @type {?}
 */
VerticalNav.ctorParameters;
/** @type {?} */
VerticalNav.propDecorators;
/** @type {?} */
VerticalNav.prototype._collapsedChanged;
/** @type {?} */
VerticalNav.prototype._sub;
/** @type {?} */
VerticalNav.prototype._navService;
/** @type {?} */
VerticalNav.prototype._navIconService;
/** @type {?} */
VerticalNav.prototype._navGroupRegistrationService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
